import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { login, checkAuthType } from "../helperFunctions/apiFunction";
import { setLoginStatus, setUserInfo, setRes } from "../redux/dataSlice";
import toast from "react-hot-toast";
import TermsNConditions from "../components/modal/TermsNConditions";
import { Spinner } from "@material-tailwind/react";
import LoginImg from "../assets/images/login-image.png";
import { decryptData, encryptData } from "./../utils/Encryption";
import entraId from "../assets/images/entra-id-logo.png";

function Login() {
  const { isLoggedIn, basicToken } = useSelector((state) => state.clientData);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ name: "" });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [step, setStep] = useState(1);
  const [authType, setAuthType] = useState("");

  const validateForm = () => {
    const newErrors = {};
    if (!Email.trim()) newErrors.Email = "Email is required";
    if (!Password.trim()) newErrors.Password = "Password is required";
    setErrors(newErrors);
  };

  const handleBlur = () => {
    validateForm();
  };

  const handleNextStep = () => {
    validateForm();
    if (!Email.trim()) return;
    setLoading(true);
    checkAuthType({ email: Email })
      .then((res) => {
        if (res?.code === 200) {
          setAuthType(res?.data);
          toast.success(`${res?.message} verified`, {
            className: "text-[12px]",
          });
          setStep(2);
        } else {
          setStep(1);
          setEmail("");
          toast.error(res?.message, {
            className: "text-[12px]",
          });
        }
      })
      .catch(() => toast.error("Error checking auth type"))
      .finally(() => setLoading(false));
  };

  const handleKey = (e) => {
    if (e.key === "Enter") {
      handleNextStep();
    }
  };

  const handleLogin = (e) => {
    if (e) {
      e.preventDefault();
    }
    setLoading(true);
    validateForm();
    if (Object.keys(errors).length === 0) {
      const obj = { email: Email, password: Password };
      login(obj, basicToken)
        .then((res) => {
          if (res.code === 200) {
            const {
              data: {
                tokens: { refresh, access },
                user,
              },
            } = res;
            const accessToken = access.token;
            dispatch(setLoginStatus({ status: true }));
            dispatch(setUserInfo({ info: { ...user, refresh } }));
            dispatch(setRes({ res }));
            localStorage.setItem("access_token", encryptData(accessToken));
            localStorage.setItem(
              "rbac",
              encryptData(user.roleId?.rolePermission)
            );
            localStorage.setItem(
              "user_info",
              encryptData({ ...user, refresh })
            );
            toast.success(res?.message, {
              className: "text-[12px]",
            });
          } else {
            toast.error(res?.message, {
              className: "text-[12px]",
            });
          }
        })
        .catch((e) => {
          toast.error("Something went wrong!", {
            className: "text-[12px]",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const hanlePassKey = (e) => {
    validateForm();
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      setEmail(value);
      setErrors((prevErrors) => ({ ...prevErrors, Email: "" }));
    } else if (name === "password") {
      setPassword(value);
      setErrors((prevErrors) => ({ ...prevErrors, Password: "" }));
    }
  };

  useEffect(() => {
    setIsLoading(false);
  }, [isLoading]);

  useEffect(() => {
    if (isLoggedIn) {
      const decryptedUserInfo = decryptData(localStorage.getItem("user_info"));
      if (decryptedUserInfo && decryptedUserInfo.role) {
        const { role } = decryptedUserInfo;
        if (role === "client") {
          navigate(`/analytics-dashboard`);
        } else {
          navigate(`/dashboard`);
        }
      } else {
        console.warn("No valid user info found in localStorage.");
      }
    }
  }, [isLoggedIn, navigate]);

  return isLoading ? (
    <div className="flex item-center text-black justify-center h-screen bg-blue-gray-100 blur-3xl cursor-wait">
      <Spinner className="h-10 w-10 text-black" />
    </div>
  ) : (
    <>
      <div className="flex h-screen">
        <div
          className="hidden lg:flex items-center justify-center flex-auto bg-white text-black"
          style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
        >
          <div className="text-center">
            <img src={LoginImg} alt="" className="w-[800px]" loading="lazy" />
          </div>
        </div>
        <div className="w-full bg-white lg:w-2/5 flex items-center justify-center shadow-2xl">
          <div className="max-w-md w-full p-6">
            <div className="flex pb-3"></div>
            <h1 className="text-2xl font-semibold mb-6 text-[#1e3558]">
              <span className="text-[#a9dbdc]  px-2 bg-[#1e3558]">
                Welcome!
              </span>{" "}
              Sign in to continue
            </h1>
            <form className="space-y-4 md:space-y-6" onSubmit={handleLogin}>
              {step === 1 && (
                <div>
                  <label
                    htmlFor="email"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    autoComplete="off"
                    value={Email}
                    onBlur={handleBlur}
                    onChange={handleInputChange}
                    onKeyDown={handleKey}
                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg p-2.5 w-full"
                    placeholder="name@company.com"
                    required
                  />
                  {errors.Email && (
                    <p className="text-red-900 text-[12px]">{errors.Email}</p>
                  )}
                  <Button
                    loading={loading}
                    text={"Next"}
                    btnType={"button"}
                    onClick={handleNextStep}
                  />
                </div>
              )}
              {step === 2 && authType === "local" && (
                <>
                  <div>
                    <label
                      htmlFor="password"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      name="password"
                      id="password"
                      placeholder="••••••••"
                      autoComplete="off"
                      value={Password}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      onKeyDown={hanlePassKey}
                      className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                    {errors.Password && (
                      <p className="text-red-900 text-[12px]">
                        {errors.Password}
                      </p>
                    )}
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-start">
                      <div className="flex items-center h-5">
                        <input
                          id="remember"
                          aria-describedby="remember"
                          type="checkbox"
                          className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800"
                          required=""
                        />
                      </div>
                      <div className="ml-3 text-sm">
                        <label
                          htmlFor="remember"
                          className="text-gray-500 dark:text-gray-300"
                        >
                          Remember me
                        </label>
                      </div>
                    </div>
                    <div className="text-end">
                      <div className="text-black">
                        <Link
                          className="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500"
                          to={"/forgetpassword"}
                        >
                          Forgot Password?
                        </Link>
                      </div>
                    </div>
                  </div>
                  <Button
                    loading={loading}
                    text={"Submit"}
                    btnType={"submit"}
                  />
                </>
              )}

              {step === 2 && authType === "sso" && (
                <>
                  <img src={entraId} alt="" className="w-10 h-10 mx-auto" />
                  <Button
                    loading={loading}
                    text={"Login with SSO"}
                    btnType={"button"}
                  />
                </>
              )}

              <div className="mt-4 text-sm text-gray-600 text-center">
                <button>
                  By logging in, you agree to our{""}
                  <b
                    className="mx-1 cursor-pointer hover:underline"
                    onClick={() => {
                      setIsModalOpen(true);
                    }}
                  >
                    Terms and Conditions
                  </b>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <TermsNConditions
        isOpen={isModalOpen}
        onRequestClose={() => {
          setIsModalOpen(false);
        }}
      />
    </>
  );
}
export default Login;

const Button = ({ loading, text, btnType, onClick }) => {
  return (
    <button
      type={btnType || "button"}
      onClick={onClick}
      className={`w-full bg-black h-[40px] my-3 flex items-center justify-center rounded-xl cursor-pointer relative overflow-hidden transition-all duration-500 ease-in-out shadow-md hover:scale-105 hover:shadow-lg before:absolute before:top-0 before:-left-full before:w-full before:h-full before:bg-gradient-to-r before:from-[#a9dbdc] before:to-[#1e3558] before:transition-all before:duration-500 before:ease-in-out before:z-[-1] before:rounded-xl hover:before:left-0 text-[#fff] ${
        loading ? "cursor-progress" : null
      }`}
    >
      {loading ? (
        <div>
          <h1 className="text-md font-bold flex items-center">
            L
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 24 24"
              className="animate-spin"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM13.6695 15.9999H10.3295L8.95053 17.8969L9.5044 19.6031C10.2897 19.8607 11.1286 20 12 20C12.8714 20 13.7103 19.8607 14.4956 19.6031L15.0485 17.8969L13.6695 15.9999ZM5.29354 10.8719L4.00222 11.8095L4 12C4 13.7297 4.54894 15.3312 5.4821 16.6397L7.39254 16.6399L8.71453 14.8199L7.68654 11.6499L5.29354 10.8719ZM18.7055 10.8719L16.3125 11.6499L15.2845 14.8199L16.6065 16.6399L18.5179 16.6397C19.4511 15.3312 20 13.7297 20 12L19.997 11.81L18.7055 10.8719ZM12 9.536L9.656 11.238L10.552 14H13.447L14.343 11.238L12 9.536ZM14.2914 4.33299L12.9995 5.27293V7.78993L15.6935 9.74693L17.9325 9.01993L18.4867 7.3168C17.467 5.90685 15.9988 4.84254 14.2914 4.33299ZM9.70757 4.33329C8.00021 4.84307 6.53216 5.90762 5.51261 7.31778L6.06653 9.01993L8.30554 9.74693L10.9995 7.78993V5.27293L9.70757 4.33329Z"></path>
            </svg>{" "}
            ading . . .
          </h1>
        </div>
      ) : (
        text
      )}
    </button>
  );
};
